import React, { useState, useEffect, useCallback } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Status from 'FielderUtils/status/routeStatus';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const baseStatusStyles = {
  'Fielder-task-managing': {
    backgroundColor: '#63a1e781',
    colorLight: '#0f5099',
    colorDark: '#b3d9ff',
  },
  'Fielder-task-waiting-for-agent': {
    backgroundColor: '#86ebd460',
    colorLight: '#20ad8f',
    colorDark: '#78f0d2',
  },
  'Fielder-task-in-progress': {
    backgroundColor: '#1b7adf70',
    colorLight: '#065ebd',
    colorDark: '#9dc8ff',
  },
  'Fielder-task-executing': {
    backgroundColor: '#0980cf6b',
    colorLight: '#0775be',
    colorDark: '#8ac4ff',
  },
  'Fielder-task-cancel': {
    backgroundColor: '#e9343469',
    colorLight: '#c21010',
    colorDark: '#ff7b7b',
  },
  'Fielder-task-finish': {
    backgroundColor: '#3ad38e79',
    colorLight: '#137c4d',
    colorDark: '#7dffca',
  },
  'Fielder-task-rejected': {
    backgroundColor: '#ef5a6473',
    colorLight: '#f93b48',
    colorDark: '#ff9ca3',
  },
};

const RouteStatus = ({ value }) => {
  const lan = useLanguage();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const [text, setText] = useState('');
  const [colorKey, setColorKey] = useState('');
  const getStatusData = useCallback(() => {
    switch (value) {
      case Status.MANAGING:
        return { text: 'taskStatus_0', color: 'Fielder-task-managing' };
      case Status.WAITING_FOR_AGENT:
        return { text: 'taskStatus_3', color: 'Fielder-task-waiting-for-agent' };
      case Status.IN_PROGRESS:
        return { text: 'taskStatus_4', color: 'Fielder-task-in-progress' };
      case Status.EXECUTING:
        return { text: 'taskStatus_5', color: 'Fielder-task-executing' };
      case Status.CANCELLED:
        return { text: 'taskStatus_1', color: 'Fielder-task-cancel' };
      case Status.FINISHED:
        return { text: 'taskStatus_2', color: 'Fielder-task-finish' };
      case Status.REJECTED:
        return { text: 'taskStatus_17', color: 'Fielder-task-rejected' };
      default:
        return null;
    }
  }, [value]);
  const setStatus = useCallback(() => {
    const status = getStatusData(value);
    if (status) {
      setColorKey(status.color);
      setText(lan[status.text]);
    } else {
      setColorKey('');
      setText('');
    }
  }, [value, getStatusData, lan]);

  useEffect(() => {
    setStatus(value);
  }, [value, setStatus]);
  let variant = 'body2';
  if (isXs) variant = 'caption';
  else if (isSm) variant = 'body2';
  else if (isMd) variant = 'subtitle2';
  const styleDef = baseStatusStyles[colorKey] || {};
  const containerSx = {
    width: '80%',
    mx: 'auto',
    borderRadius: 1.5,
    py: 1,
    px: 1.25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'default',
    backgroundColor: styleDef.backgroundColor,
    color: isDark ? styleDef.colorDark : styleDef.colorLight,
    transition: 'color 0.3s ease',
  };
  return (
    <Box sx={containerSx}>
      <Typography
        variant={variant}
        noWrap
        sx={{ textAlign: 'center'}}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default RouteStatus;

//Original code:
/*import React, { useState, useEffect, useCallback } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Status from 'FielderUtils/status/routeStatus';
import Grid from '@mui/material/Grid2';

const RouteStatus = ({ value }) => {
	const lan = useLanguage();
	const [text, setText] = useState('');
	const [color, setColor] = useState('');
	const getStatusData = useCallback(() => {
		switch (value) {
			case Status.MANAGING:
				return {
					text: `taskStatus_0`,
					color: 'Fielder-task-managing',
				};
			case Status.WAITING_FOR_AGENT:
				return {
					text: `taskStatus_3`,
					color: 'Fielder-task-waiting-for-agent',
				};
			case Status.IN_PROGRESS:
				return {
					text: `taskStatus_4`, //In progress
					color: 'Fielder-task-in-progress',
				};
			case Status.EXECUTING:
				return {
					text: `taskStatus_5`,
					color: 'Fielder-task-executing',
				};
			case Status.CANCELLED:
				return {
					text: `taskStatus_1`,
					color: 'Fielder-task-cancel',
				};
			case Status.FINISHED:
				return {
					text: `taskStatus_2`,
					color: 'Fielder-task-finish',
				};
			case Status.REJECTED:
				return {
					text: `taskStatus_17`,
					color: 'Fielder-task-rejected',
				};
			default:
				return;
		}
	}, []);
	const setStatus = useCallback(() => {
		let status = getStatusData(value);
		if (status) {
			setColor(status.color);
			setText(lan[status.text]);
		}
	}, [value, getStatusData, lan]);
	useEffect(() => {
		setStatus(value);
	}, [value, setStatus]);
	return (
		<Grid container className={'mx-auto status-square text-center status-' + color}>
      <span className='status-text '>{text}</span>
		</Grid>
	);
};
export default RouteStatus;
*/
